import regex from './regex';
import validationMessages from './validationMessages';
import {ToastService } from 'glic-ui-components';
import CommonService from '../api-services/CommonService';
const CommonFunctions = {
  //Format url using these functions.
  formatUrl: (url, ...args) =>
    url.replace(/{(\d+)}/g, (match, number) => {
      if (!args[number]) {
        const commonService = new CommonService();
        commonService.logReactErrors(null, 
          'Common Function ', 
          'Format url function dont have arguments.');
      }
      return args[number] ? args[number] : match;
    }),
  setQueryParams(url, params) {
    if (params) {
      const filteredParams = {};
      let queryParams = '';
      Object.keys(params).forEach((key) => {
        if (params[key] || params[key] === 0 || params[key] === false) {
          filteredParams[key] = params[key];
        }
      });
      for (const [key, value] of Object.entries(filteredParams)) {
        queryParams += `&${key}=${value}`;
      }
      return url.indexOf('?') === -1 && queryParams
        ? `${url}?${queryParams.substr(1)}`
        : url;
    }
    return url;
  },
  getQueryParam(field, url) {
    const href = url || window.location.href;
    const reg = new RegExp(`[?]${field}=([^#]*)`, 'i');
    const string = reg.exec(href);
    return string ? string[1] : null;
  },
  // Validates that the input string is a valid date formatted as "mm/dd/yyyy"
  isValidDate(dateString) {
    // First check for the pattern
    if (!/^\d{1,2}\/\d{1,2}\/\d{4}$/.test(dateString)) return false;

    // Parse the date parts to integers
    var parts = dateString.split('/');
    var day = parseInt(parts[1], 10);
    var month = parseInt(parts[0], 10);
    var year = parseInt(parts[2], 10);

    // Check the ranges of month and year
    if (year < 1000 || year > 3000 || month === 0 || month > 12) return false;

    var monthLength = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

    // Adjust for leap years
    if (year % 400 === 0 || (year % 100 !== 0 && year % 4 === 0))
      monthLength[1] = 29;

    // Check the range of the day
    return day > 0 && day <= monthLength[month - 1];
  },
  getTodaysDate(dob) {
    const monthNames = [
      '01',
      '02',
      '03',
      '04',
      '05',
      '06',
      '07',
      '08',
      '09',
      '10',
      '11',
      '12',
    ];
    const dateObj = new Date(dob);
    const month = monthNames[dateObj.getMonth()];
    const day = String(dateObj.getDate()).padStart(2, '0');
    const year = dateObj.getFullYear();
    return `${month}/${day}/${year}`;
  },
  isEmpty: (value) => {
    return typeof value === 'undefined' || value == null || value.length === 0;
  },

  isEmailValid: (email) => {
    return regex.EMAIL.test(email);
  },
 
  /***
   * How to use: 
   * 2 OPTIONS - 
   * 1st OPTION - errorHandler.bind(this, <componentName>);
   * Description: To log component name we need to bind context object and need to pass component name from respective component.
   * 2nd OPTION - errorHandler(<component name>, error)
   * Description: To log direct error and component name we can directly call this funtion with the available params.
   */
  errorHandler : (componentName = '',error = {}) => {
    const commonService = new CommonService();
    let message = error?.error?.response?.data?.Data?.Message || validationMessages.somethingWentWrong;

    commonService.logReactErrors(error, componentName, 'Error handler');
    ToastService.show(message, {
      type: 'error',
    });
  },
};
export default CommonFunctions;
